import DashboardFilterIcon from "../../assets/down-arrow-black.svg";
import CalendarIcon from "../../assets/calendar_blue.svg";
import { APPLICABLE_ROLE } from "../DashboardAppointmentsView/Constant";
import { USER_ROLE } from "../../Util/constants";
import moment from "moment";

export const DEFAULT_TRANSACTIONS_PAYLOAD = {
  search_string: "",
  page_no: 1,
  page_number: 1,
  sort_order: "most_recent_first",
  payment_status: "all",
  payment_status_filter: "all",
  consultation_filter: "",
  payment_method_filter: "all",
  is_all_data: false,
  start_date: moment().format("YYYY-MM-DD"),
  end_date: moment().format("YYYY-MM-DD"),
  procedure_type_filter: "",
  rows_per_page: 10,
  partial_amount_filter: "",
};

export const HEADER_TYPE_LIST = {
  APPNT_DATE_TIME: "APPOINTMENT DATE & TIME",
  DOCTOR_NAME: "DOCTOR NAME",
  PROCEDURE: "PROCEDURE",
  PAYMENT_METHOD: "PAYMENT METHOD",
  PAYMENT_DATE_STATUS: "PAYMENT TRANSFERRED DATE & STATUS",
  AMOUNT: "AMOUNT",
};

export const HEADER_LIST = {
  PATIENT_INFORMATION: "Patient Information",
  APPNT_DATE_TIME: "APPOINTMENT DATE & TIME",
  DOCTOR_NAME: "Doctor / Resource Name",
  PROCEDURE: "Procedure",
  PAYMENT_METHOD: "Payment Method",
  PAYMENT_DATE_STATUS: "Payment Status",
  STATUS: "Status",
  AMOUNT: "Total Amount",
  PAID: "Paid",
  PENDING: "Pending",
  RECEPIT_NO: "Receipt No.",
  RECEIPT: "Receipt",
};

export const MOBILE_FILTER_LIST = {
  DATE: "Appointment Date",
  DOCTOR_NAME: "Doctor / Resource Name",
  PROCEDURE: "Procedure",
  PAYMENT_METHOD: "Payment Method",
  PAYMENT_STATUS: "Payment Status",
  AMOUNT_FILTER: "Amount",
};

export const FILTER_ICON_TYPE = {
  NORMAL: "normal",
  DATE: "date",
  PROCEDURE: "procedure",
};

export const TRANSACTIONS_HEADER_LIST = [
  {
    id: 1,
    type: HEADER_TYPE_LIST.APPNT_DATE_TIME,
    title: HEADER_LIST.APPNT_DATE_TIME,
    mobileFilterTitle: MOBILE_FILTER_LIST.DATE,
    filterIcon: CalendarIcon,
    filterType: FILTER_ICON_TYPE.DATE,
    showFilter: false,
    menuData: [],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    isFilterApplied: false,
  },
  {
    id: 2,
    type: HEADER_TYPE_LIST.DOCTOR_NAME,
    title: HEADER_LIST.DOCTOR_NAME,
    mobileFilterTitle: MOBILE_FILTER_LIST.DOCTOR_NAME,
    filterIcon: DashboardFilterIcon,
    filterType: FILTER_ICON_TYPE.NORMAL,
    showFilter: false,
    menuData: [],
    applicableRoles: [
      USER_ROLE.DOCTOR_ADMIN,
      USER_ROLE.RESOURCE_ADMIN,
      APPLICABLE_ROLE.STAFF,
    ],
    className: "my-transactions-header-doctor-name",
    isFilterApplied: false,
  },
  {
    id: 3,
    type: HEADER_TYPE_LIST.PROCEDURE,
    title: HEADER_LIST.PROCEDURE,
    mobileFilterTitle: MOBILE_FILTER_LIST.PROCEDURE,
    filterIcon: DashboardFilterIcon,
    filterType: FILTER_ICON_TYPE.PROCEDURE,
    showFilter: false,
    menuData: [],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    showFilterSearchbar: true,
    placeholderForSearch: "Search",
    className: "my-transactions-header-procedures",
    isFilterApplied: false,
  },
  {
    id: 4,
    type: HEADER_TYPE_LIST.PAYMENT_METHOD,
    title: HEADER_LIST.PAYMENT_METHOD,
    mobileFilterTitle: MOBILE_FILTER_LIST.PAYMENT_METHOD,
    filterIcon: DashboardFilterIcon,
    filterType: FILTER_ICON_TYPE.NORMAL,
    showFilter: false,
    menuData: [],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    className: "my-transactions-header-payment-method",
    isFilterApplied: false,
  },
  {
    id: 5,
    type: HEADER_TYPE_LIST.PAYMENT_DATE_STATUS,
    title: HEADER_LIST.PAYMENT_DATE_STATUS,
    mobileFilterTitle: MOBILE_FILTER_LIST.PAYMENT_STATUS,
    filterIcon: DashboardFilterIcon,
    filterType: FILTER_ICON_TYPE.NORMAL,
    showFilter: false,
    menuData: [],
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    isFilterApplied: false,
  },
  {
    id: 6,
    type: HEADER_TYPE_LIST.AMOUNT,
    title: HEADER_LIST.AMOUNT,
    mobileFilterTitle: MOBILE_FILTER_LIST.AMOUNT_FILTER,
    filterIcon: DashboardFilterIcon,
    filterType: FILTER_ICON_TYPE.NORMAL,
    showFilter: false,
    menuData: [],
    applicableRoles: [
      USER_ROLE.DOCTOR_ADMIN,
      USER_ROLE.RESOURCE_ADMIN,
      APPLICABLE_ROLE.STAFF,
    ],
    className: "my-transactions-header-amount",
    isFilterApplied: false,
  },
];

export const PAYMENT_STATUS_FILTER = [
  {
    name: "All",
    value: "all",
    selected: true,
  },
  {
    name: "Success",
    value: "success",
    selected: false,
  },
  {
    name: "Pending",
    value: "pending",
    selected: false,
  },
];

export const AMOUNT_FILTER = [
  {
    name: "All",
    value: "all",
    selected: true,
  },
  {
    name: "Partial Fee",
    value: "partial_amount",
    selected: false,
  },
];

export const PAYMENT_METHOD_FILTER = [
  {
    name: "All",
    value: "all",
    selected: true,
  },
  {
    name: "Online",
    value: "online",
    selected: false,
  },
  {
    name: "Paid at Clinic",
    value: "by-cash",
    selected: false,
  },
  {
    name: "Multiple Modes",
    value: "multiple_modes",
    selected: false,
  },
];

export const CONSULTATION_FILTER = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Tele-Consult Regular",
    value: "online-regular",
  },
  {
    name: "Tele-Consult Follow-Up",
    value: "online-followup",
  },
  {
    name: "In-Clinic Regular",
    value: "inclinic-regular",
  },
  {
    name: "In-Clinic Follow-Up",
    value: "inclinic-followup",
  },
  {
    name: "Instant",
    value: "instant",
  },
];

export const API_FILTER_LIST = {
  CONSULTATION: "consultation_filter",
  PROCEDURE: "procedure_type_filter",
  PROCEDURE_VALUE: "procedure_type_filter_value",
  STARTDATE: "start_date",
  ENDDATE: "end_date",
  DOCTORNAME: "doctor_ids",
  DOCTOR_NAME: "doctor_name",
  SEARCHSTRING: "search_string",
  SORTORDER: "sort_order",
  PAYMENT_METHOD: "payment_method_filter",
  PAYMENT_METHOD_VALUE: "payment_method_value",
  PAYMENT_STATUS: "payment_status",
  PAGENO: "page_no",
  CONSULTATION_TYPE: "consultation_type",
  AMOUNT_FILTER: "partial_amount_filter",
  AMOUNT_VALUE: "partial_amount_value",
};

export const TRANSACTION_DROPDOWN = [
  {
    id: 1,
    label: "My Transactions",
  },
  {
    id: 2,
    label: "Day Collection",
  },
];
export const COLLECTION_DETAILS_TABLE_HEADER = [
  {
    id: 1,
    title: "User Name",
    className: "cdtvc-user-name",
  },
  {
    id: 2,
    title: "Appointment",
    className: "cdtvc-appointment",
  },
  { id: 3, title: "Patient details", className: "cdtvc-patient-details" },
  {
    id: 4,
    title: "Doctor / Resource Name",
    className: "cdtvc-doctor-resource-name",
  },
  { id: 5, title: "Transaction id", className: "cdtvc-transaction-id" },
  { id: 6, title: "Payment Method", className: "cdtvc-payment0-method" },
  { id: 7, title: "Receipt Amount", className: "cdtvc-receipt-amount" },
  { id: 8, title: "Receipt Number", className: "cdtvc-receipt-number" },
];

export const COLLECTION_SUMMARY_TABLE_HEADER = [
  {
    id: 1,
    name: "User Name",
    className: "cstv-username",
  },
  {
    id: 2,
    name: "Cash",
    className: "cstv-cash",
  },
  {
    id: 3,
    name: "C2C Online",
    className: "cstv-online",
  },
  {
    id: 4,
    name: "Others",
    hoverMsg:
      "Google Pay, Paytm, PhonePe, Credit/Debit Card, Netbanking, Amazon Pay & Others",
    className: "cstv-others",
  },
  {
    id: 5,
    name: "Total",
    className: "cstv-total",
  },
];

export const TRANSACTIONS_TABLE_HEADER_LIST = [
  {
    id: 1,
    title: HEADER_LIST.PATIENT_INFORMATION,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },
  {
    id: 2,
    title: HEADER_LIST.DOCTOR_NAME,
    applicableRoles: [
      USER_ROLE.DOCTOR_ADMIN,
      USER_ROLE.RESOURCE_ADMIN,
      APPLICABLE_ROLE.STAFF,
    ],
  },
  {
    id: 3,
    title: HEADER_LIST.PROCEDURE,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },
  {
    id: 4,
    title: HEADER_LIST.PAYMENT_METHOD,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },
  {
    id: 5,
    title: HEADER_LIST.STATUS,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },
  {
    id: 6,
    title: HEADER_LIST.PAID,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },
  {
    id: 7,
    title: HEADER_LIST.PENDING,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },
  {
    id: 8,
    title: HEADER_LIST.AMOUNT,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },
  {
    id: 9,
    title: HEADER_LIST.RECEPIT_NO,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },

  {
    id: 10,
    title: HEADER_LIST.RECEIPT,
    applicableRoles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  },
];

export const dateFilter = [
  {
    name: "Today",
    value: "Today",
  },
  {
    name: "Last 7 Days",
    value: "Last 7 Days",
  },
  {
    name: "Last 30 Days",
    value: "Last 30 Days",
  },
  {
    name: "Custom Date Range",
    value: "Custom Date Range",
  },
];

export const DAY_COLLECTION_MIN_DATE = {
  PROD: "08-24-2024",
  MAINT: "08-24-2024",
  UAT: "08-21-2024",
  QA: "08-16-2024",
  DEV: "08-14-2024",
};

export const DOWNLOAD_REPORT_TYPE = [
  {
    id: 1,
    label: "Summary Report",
    value: "summary",
    selected: false,
    disabled: false,
  },
  {
    id: 2,
    label: "Detail Report",
    value: "transactions",
    selected: true,
    disabled: false,
  },
];
